import React, { useEffect, useState } from 'react';
import { getProductos } from '../services/api';

/**
 * Campo de descripción con buscador del catálogo de productos.
 * - Escribe libre o busca por nombre/código; al elegir uno, llama onPick(producto).
 * - onChangeText mantiene el texto libre (para descripciones sin catálogo).
 * Reutilizable en factura, cotización y factura recurrente.
 */
export default function ProductoPicker({ value, onChangeText, onPick, style, placeholder = 'Descripción o buscar producto…' }) {
  const [q, setQ] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { setQ(value || ''); }, [value]);
  useEffect(() => {
    if (!open) return;
    const term = (q || '').trim();
    if (term.length < 2) { setResults([]); return; }
    const t = setTimeout(async () => {
      try { const { data } = await getProductos(term); setResults((data || []).slice(0, 20)); }
      catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  const fmtP = (n) => Number(n) > 0 ? '$' + Number(n).toLocaleString('es-CO') : '';

  return (
    <div style={{ position: 'relative', flex: style?.flex, minWidth: 0 }}>
      <input style={{ ...style, width: '100%', flex: undefined }} placeholder={placeholder} value={q}
        onChange={e => { setQ(e.target.value); onChangeText(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 160)} />
      {open && results.length > 0 && (
        <div style={s.box}>
          {results.map(p => (
            <div key={p.id} style={s.item} onMouseDown={() => { onPick(p); setOpen(false); }}>
              <div style={{ color: '#f1f5f9', fontSize: 12.5 }}>{p.nombre}</div>
              <div style={{ color: '#64748b', fontSize: 11 }}>
                {p.codigo ? p.codigo + ' · ' : ''}{p.unidad} · IVA {p.iva_pct}%{fmtP(p.precio_unitario) ? ' · ' + fmtP(p.precio_unitario) : ''}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  box: { position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 70, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, maxHeight: 260, overflowY: 'auto', boxShadow: '0 12px 32px rgba(0,0,0,.55)' },
  item: { padding: '7px 11px', cursor: 'pointer', borderBottom: '1px solid #1e293b' },
};
